import { Signal } from '@preact/signals';
import { savePosition } from './usePanelDrag';

interface Position {
  x: number;
  y: number;
}

/**
 * Clamp panel position to stay within viewport bounds
 */
export function clampPositionToViewport(
  panelRef: { current: HTMLDivElement | null },
  position: Signal<Position | null>,
  panelId?: string
): void {
  if (!panelRef.current || !position.value) return;

  const rect = panelRef.current.getBoundingClientRect();
  // Compute max allowed x/y so panel remains in viewport
  const maxX = Math.max(0, window.innerWidth - rect.width);
  const maxY = Math.max(0, window.innerHeight - rect.height);

  let { x, y } = position.value;
  const newX = Math.max(0, Math.min(x, maxX));
  const newY = Math.max(0, Math.min(y, maxY));

  if (newX !== x || newY !== y) {
    position.value = { x: Math.round(newX), y: Math.round(newY) };
    if (panelId) {
      // Persist corrected position
      savePosition(panelId, position.value);
    }
  }
}
